<template>
	<div>
		<el-table stripe :data="tableData" style="width: 100%;margin-bottom: 20px; color: #000;" border
			@sort-change="changeTableSort" size="mini" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="stu_idx" label="序号" width="60"></el-table-column>
			<el-table-column prop="stu_idx" v-if="showidx" label="编号" width="60"></el-table-column>
			<el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>
			<!-- <el-table-column prop="archive" label="建档号" width="120"></el-table-column> -->
			<el-table-column prop="exam_num" label="准考证号" width="120"></el-table-column>
			<el-table-column prop="exam_score" label="总分" width="60" align="center">
				<template slot-scope="scope">
					<span v-if="scope.row.scoreOk" style="color:blue; font-weight: bolder;">{{ scope.row.exam_score
					}}</span>
					<span v-else style="color:orangered; font-weight: bolder;">{{ scope.row.exam_score }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="volunteer" label="志愿" width="80">
				<template slot-scope="scope">

					<span v-if="scope.row.volunteer == 1">第一志愿</span>
					<span v-if="scope.row.volunteer == 2">第二志愿</span>
					<span v-if="scope.row.volunteer == 3">第三志愿</span>
					<span v-if="scope.row.volunteer == 0">服从志愿</span>
				</template>
			</el-table-column>
			<el-table-column prop="gender" label="性别" width="60">
				<template slot-scope="scope">

					<span v-if="scope.row.gender == 1">男</span>
					<span v-if="scope.row.gender == 2">女</span>

					<span v-if="scope.row.gender == 0">未知</span>
				</template>
			</el-table-column>
			<el-table-column prop="graduate_sch_city" label="地区" width="150"></el-table-column>
			<!-- <el-table-column prop="yuanxi_name" label="系部" width="120"></el-table-column> -->
			<el-table-column prop="major_name" label="专业" min-width="140"></el-table-column>


			<el-table-column prop="phone" label="联系方式" min-width="120">
				<template slot-scope="scope">
					<span>{{ scope.row.phone || scope.row.jhr1phone }}</span>

				</template>
			</el-table-column>

			<el-table-column prop="status" label="状态" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.status == 1" style="color: green;">已审核</span>
					<span v-if="scope.row.status == 2" style="color: blue;">已缴费</span>
					<span v-if="scope.row.status == 3" style="color: deepskyblue;">已录取</span>
					<span v-if="scope.row.status == 4" style="color: #096DD9;">已分班</span>
					<span v-if="scope.row.status == -1 && $store.state.pmid == 7" style="color: orangered;">退回</span>
					<span v-if="scope.row.status == -1 && $store.state.pmid != 7" style="color: orangered;">不通过</span>
					<span v-if="scope.row.status == 0" style="color: gray;">未审核</span>
				</template>
			</el-table-column>
			<el-table-column prop="cdate" label="报名时间" width="150"></el-table-column>
			<el-table-column prop="username" label="审核员" width="100"></el-table-column>
			<el-table-column prop="cdate" label="审核时间" width="150">
				<template slot-scope="scope">
					<span v-if="scope.row.username">{{ scope.row.udate }}</span>
				</template>
			</el-table-column>



			<el-table-column fixed="right" label="操作" width="140" v-if="$store.state.teacherRole.isadmin">
				<template slot-scope="scope">
					<el-button v-if="scope.row.status >= 1 && $store.state.pmid == 4" @click="printView(scope.row)"
						type="text" size="small">打印</el-button>
					<el-button v-if="scope.row.status < 1 && $store.state.pmid != 2 && $store.state.pmid != 10"
						@click="handleModify(scope.row)" type="text" size="small">审核</el-button>
					<el-button v-if="scope.row.status < 1 && $store.state.pmid == 5" @click="handleModify(scope.row)"
						type="text" size="small">审核</el-button>
					<el-button v-if="scope.row.status != -1 && scope.row.status != 1 && $store.state.pmid == 10"
						@click="handleModify(scope.row)" type="text" size="small">审核</el-button>
					<el-button v-if="scope.row.status == 1 || ($store.state.pmid == 10 && scope.row.status == -1)"
						@click="handleView(scope.row)" type="text" size="small">详情</el-button>
					<el-button v-if="scope.row.status == 1" @click="handleBack(scope.row)" type="text" size="small">退回
					</el-button>
					<el-popconfirm width="200" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info"
						iconColor="red" @confirm="handleDel(scope.row)" placement="left" title="是否确定删除？">
						<a v-if="$store.state.teacherRole.isadmin && $store.state.pmid != 2" slot="reference"
							size="small" style="color: red;font-size: 12px;margin-left: 10px; cursor: pointer;">删除</a>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize"
			:total="page.total" @size-change="handleSizeChange" :page-sizes="page.pageSizes"
			layout="total, prev, pager, next, sizes, jumper">
		</el-pagination>
	</div>
</template>
<script>
export default {
	name: 'Table',
	data() {
		return {

		}
	},
	props: {
		page: {
			type: Object,
		},
		tableData: {
			type: Array,
			default: []
		},
		from: {
			type: String,
			default: ''
		},
		multSelect: {
			type: Boolean,
			default: true
		},
		showidx: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleModify(row) {
			this.$emit('handleModify', row)
		},
		handleView(row) {
			this.$emit('handleView', row)
		},
		handleDel(row) {
			this.$emit('handleDel', row)
		},
		handleSelectionChange(val) {
			this.$emit('handleSelectionChange', val)
		},
		handlePageChange(e) {
			this.$emit('handlePageChange', e)
		},
		handleSizeChange(e) {
			this.$emit('handleSizeChange', e)
		},
		printView(e) {
			this.$emit('printView', e)
		},
		changeTableSort(column) {
			this.$emit('changeTableSort', column)

		},
		handleBack(e) {
			this.$confirm('确定退回?退回后审核状态将恢复至未审核！', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post("/api/back_student_pre", { id: e.id }).then(res => {
					this.$message.success('退回成功！')
					this.$parent.$parent.$parent.getList()
				})
			})
		}
	}
}
</script>
